import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { SERVICE_AREAS, IMAGES } from "../../data/site";

export const ServiceArea = () => {
    return (
        <section
            id="area"
            data-testid="service-area-section"
            className="relative py-24 md:py-32 overflow-hidden"
        >
            <div className="absolute inset-0 -z-10">
                <img
                    src={IMAGES.chicago}
                    alt="Chicago skyline"
                    className="w-full h-full object-cover opacity-15"
                />
                <div className="absolute inset-0 bg-bone/85" />
            </div>
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 reveal items-end">
                    <div className="lg:col-span-7">
                        <div className="text-xs tracking-[0.22em] uppercase font-bold text-moss mb-5">
                            <span className="h-px w-10 bg-moss inline-block align-middle mr-3" />
                            Where We Work
                        </div>
                        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.05] tracking-tight">
                            Chicago Southland &<br />
                            Northwest Indiana — <span className="text-copper">that&apos;s home.</span>
                        </h2>
                    </div>
                    <p className="lg:col-span-5 text-muted_ink leading-relaxed">
                        We don&apos;t chase out-of-area jobs. We focus on the corridor we know
                        cold — older Chicago bungalows, suburban ranches, and new-builds across
                        the south suburbs and into NW Indiana.
                    </p>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-px bg-line border border-line">
                    {SERVICE_AREAS.map((a, idx) => (
                        <Link
                            key={a.slug}
                            to={`/areas/${a.slug}`}
                            data-testid={`service-area-${a.slug}`}
                            className="bg-bone hover:bg-white p-6 md:p-8 flex items-center gap-4 group reveal transition-colors"
                            style={{ transitionDelay: `${(idx % 9) * 50}ms` }}
                        >
                            <MapPin
                                size={20}
                                strokeWidth={1.5}
                                className="text-copper shrink-0 group-hover:scale-110 transition-transform"
                            />
                            <div>
                                <div className="font-heading font-bold text-lg leading-tight">
                                    {a.city}
                                </div>
                                <div className="text-xs uppercase tracking-wider text-muted_ink">
                                    {a.state} · {a.zip}
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>

                <p
                    data-testid="service-area-footnote"
                    className="text-sm text-muted_ink mt-8 reveal"
                >
                    Not on the list? Call us — we routinely book work in the surrounding zips.{" "}
                    <Link
                        to="/sitemap"
                        className="link-underline font-semibold text-ink"
                        data-testid="service-area-sitemap-link"
                    >
                        Browse all services & areas →
                    </Link>
                </p>
            </div>
        </section>
    );
};
